// Reducer vertex schema
// Simple passive device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

export const ReducerVertexSchema = BaseVertexSchema.extend({
  type: z.literal('reducer'),
  elevation: ValueWithUnitSchema,
  // C++ emits transition_length only when is_set() (per as_json audit § 4).
  transition_length: ValueWithUnitSchema.optional(),
});

export type ReducerVertex = z.infer<typeof ReducerVertexSchema>;
